import React, { useState } from "react";
import { VtrTag } from "../../common/contexts/TagsContext";

interface VtrTagCardProps {
  tag: VtrTag;
  onDelete: () => void;
  onUpdate: (label: string, color: string) => void;
}

export const VtrTagCard: React.FC<VtrTagCardProps> = ({ tag, onDelete, onUpdate }) => {
  const [edits, setEdits] = useState<{ label?: string; color?: string }>({});

  const labelVal = edits.label !== undefined ? edits.label : tag.label;
  const colorVal = edits.color !== undefined ? edits.color : tag.color;

  const handleLabelChange = (value: string) => {
    setEdits((prev) => ({ ...prev, label: value }));
  };

  const handleColorChange = (value: string) => {
    setEdits((prev) => ({ ...prev, color: value }));
    // Debounce color update
    const newLabel = edits.label !== undefined ? edits.label : tag.label;
    onUpdate(newLabel, value);
  };

  const handleBlur = () => {
    const newLabel = edits.label !== undefined ? edits.label : tag.label;
    const newColor = edits.color !== undefined ? edits.color : tag.color;

    if (newLabel.trim()) {
      onUpdate(newLabel, newColor);
    }

    setEdits({});
  };

  return (
    <div
      data-testid={`vtr-tag-card-${tag.id}`}
      style={{
        background: "var(--color-panel-bg)",
        borderRadius: "var(--border-radius-md)",
        border: `2px solid ${colorVal}`,
        padding: "10px",
        boxShadow: "var(--shadow-card)",
      }}
    >
      <div
        data-testid={`vtr-tag-header-${tag.id}`}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <input
          type="color"
          value={colorVal}
          onChange={(e) => handleColorChange(e.target.value)}
          style={{
            width: "24px",
            height: "24px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            padding: 0,
            flexShrink: 0,
          }}
          title="Tag color"
        />
        <input
          data-testid={`vtr-tag-label-input-${tag.id}`}
          value={labelVal}
          onChange={(e) => handleLabelChange(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
          style={{
            background: "transparent",
            border: "none",
            color: "var(--color-text-primary)",
            fontWeight: "bold",
            fontSize: "0.9rem",
            width: "100%",
            textTransform: "uppercase",
          }}
        />
        <button
          data-testid={`vtr-tag-delete-${tag.id}`}
          onClick={onDelete}
          style={{
            background: "transparent",
            border: "none",
            color: "var(--color-text-muted)",
            cursor: "pointer",
            fontSize: "1rem",
            flexShrink: 0,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};
